import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { DATADOG_SITE } from './site';
import type { ObservabilityConfig, ObservabilityIdentity } from './types';

export function initDatadog(config: Required<ObservabilityConfig>) {
  datadogLogs.init({
    clientToken: config.clientToken,
    env: config.env,
    forwardConsoleLogs: ['log', 'info', 'warn', 'error'],
    forwardErrorsToLogs: true,
    service: config.service,
    sessionSampleRate: 100,
    site: DATADOG_SITE,
    trackingConsent: 'not-granted',
    version: config.version,
  });

  datadogRum.init({
    allowedTracingUrls: [/https:\/\/(.*\.)?pieinsurance\.com($|\/.*)/],
    applicationId: config.applicationId,
    clientToken: config.clientToken,
    defaultPrivacyLevel: 'mask-user-input',
    enableExperimentalFeatures: ['feature_flags'],
    env: config.env,
    service: config.service,
    sessionReplaySampleRate: 100,
    sessionSampleRate: 100,
    site: DATADOG_SITE,
    trackingConsent: 'not-granted',
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    trackViewsManually: true,
    version: config.version,
  });
}

export function isDatadogInitialized() {
  return Boolean(datadogRum.getInitConfiguration());
}

export function identify(identity: ObservabilityIdentity) {
  datadogLogs.setUser(identity);
  datadogRum.setUser(identity);
}

export function setTrackingConsent(granted: boolean) {
  const trackingConsent = granted ? 'granted' : 'not-granted';
  datadogLogs.setTrackingConsent(trackingConsent);
  datadogRum.setTrackingConsent(trackingConsent);
}

export function trackView(viewName: string) {
  datadogRum.startView({ name: viewName });
}
